<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.qunLongGongDanPrintDiv {
  td {
    text-align: center;
    padding: 4px;
    font-size: 18px;
    color: black;
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/pageForPlan" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('jihuadanhao')">
            <el-input disabled v-model="$attrs.work.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')">
            <el-input disabled v-model="$attrs.work.quantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('yipaichanshuliang')">
            <el-input disabled v-model="$attrs.work.schedulingQuantity"></el-input>
          </el-form-item>

          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨  -->
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 1" type="text" @click="giveOut(scope.row)">{{ $t('fafang') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="plan_work_order_close_loading" v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 2" type="text" class="font-color-danger" @click="close(scope.row)">{{ $t('guanbi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 6 || scope.row.status == 5 || scope.row.status == 7" type="text" @click="yt.showEditDialog('gongxugongdan', scope.row, '900px')">{{ $t('gongxugongdan') }} </el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button type="text" @click="createQrCode(scope.row)" v-if="utils.checkPower('web_order_management_production_plan_qunlong_query_qr_code')">{{ $t('gongdanerweima') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="plan_work_order_re_give_out" v-if="scope.row.status == 7 && (($attrs.work.quantity - $attrs.work.schedulingQuantity) >= (scope.row.planQuantity - scope.row.finishGoodQuantity))" type="text" @click="reGiveOut(scope.row)">{{ $t('chongxinfafang') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="showUpdateTimeDialog(scope.row)" v-if="(scope.row.status == 2 || scope.row.status == 4) && (scope.row.parentId == null) && utils.checkPower('web_order_management_production_wo_update_plan_time')">{{ $t('xiugaijihuashijian') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!--修改时间-->
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="isShowUpDateTimeDialog" width="450px" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--<div class="dialog-scroller"></div>-->
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item class="noborder" :label="$t('yuanjihuakaishishijian')" required>
          {{ dayjs(currentOrders.planStartTime).format("YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item class="noborder" :label="$t('yuanjihuawanchengshijian')" required>
          {{ dayjs(currentOrders.planEndTime).format("YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item :label="$t('xianjihuakaishishijian')" required>
          <yi_time_input type="datetime" :time.sync="timeForm.planStartTime"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('xianjihuawanchengshijian')" required>
          <yi_time_input type="datetime" :time.sync="timeForm.planEndTime"> </yi_time_input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpDateTimeDialog = false">{{ $t("quxiao") }}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini" @click="updateTime" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 工序工单 -->
      <!--      :chart="yt.editObj"-->
      <template v-if="yt.editObj.action == 'gongxugongdan'">
        <div class="dialog-scroller">
          <process :processWork="yt.editObj" :work="$attrs.work"></process>
        </div>
      </template>

      <template v-if="yt.editObj.action == 'gongdanerweima'">
        <table id="qunLongGongDanPrintDiv" style="border-color: black;" class="qunLongGongDanPrintDiv" width="100%" border="1" cellspacing="0">
          <tbody>
            <tr>
              <td style="font-weight:bold" width="120">
                {{ $t('shengchanchejian') }}
              </td>
              <td width="200">
                {{ $t('zhusuerchejian') }}
                <!-- {{ yt.editObj.org.name }} -->
              </td>
              <td rowspan="5" colspan="2">
                <vue-qr :text="qrContext" :size="148" :margin="0"></vue-qr>
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('danjubianhao') }}
              </td>
              <td width="200">
                {{ yt.editObj.no }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('jitai') }}
              </td>
              <td width="200">
                {{ yt.editObj.equipment.name }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('huohao') }}
              </td>
              <td width="200">
                {{ yt.editObj.plan.articleNumber }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('wuliaobianma') }}
              </td>
              <td width="200">
                {{ yt.editObj.material.code }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('wuliaomingcheng') }}
              </td>
              <td rowspan="1" colspan="3">
                {{ yt.editObj.material.name }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('mohao') }}
              </td>
              <td rowspan="1" colspan="3">
                {{ yt.editObj.mould.name }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('shuliang') }}
              </td>
              <td rowspan="1" colspan="3">
                {{ yt.editObj.planQuantity }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('zhongliang') }}
              </td>
              <td>{{ yt.editObj.wo.weight }}</td>
              <td style="font-weight:bold">
                {{ $t('danzhong') }}
              </td>
              <td>
                {{ yt.editObj.wo.singleWeight }}
              </td>
            </tr>
            <tr>
              <td style="font-weight:bold">
                {{ $t('qiangshu') }}
              </td>
              <td>{{ yt.editObj.actualCavity }}</td>
              <td style="font-weight:bold">
                {{ $t('zhouqi') }}
              </td>
              <td>{{ yt.editObj.standardCycle }}</td>
            </tr>
          </tbody>
        </table>
        <div style="text-align: center;">
          <el-button type="primary" style="margin-bottom:20px;margin-top: 20px; " @click="dayin">打印</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import process from '@@/pages/web/order_management/production_plan/work_order/process';
import VueQr from 'vue-qr';
import html2canvas from 'html2canvas';
import print from 'print-js';
import utils from '@/common/utils';

export default {
  name: 'web_order_management_production_plan_senmusi_work_order_list',
  components: {
    process,
    VueQr,
    utils
  },
  data() {
    return {
      isShowUpDateTimeDialog: false,
      timeForm: {
        planStartTime: null,
        planEndTime: null,
      },
      currentOrders: {},
      qrContext: '',
      plan_work_order_close_loading: false,
      plan_work_order_re_give_out: false,
      status: [
        {
          label: this.$t('xinjian'),
          value: 1
        },
        {
          label: this.$t('fafang'),
          value: 2
        },
        {
          label: this.$t('shengchanzhong'),
          value: 3
        },
        {
          label: this.$t('zanting'),
          value: 4
        },
        {
          label: this.$t('shougongxuwangong'),
          value: 5
        },
        {
          label: this.$t('wangong'),
          value: 6
        },
        {
          label: this.$t('guanbi'),
          value: 7
        },
        {
          label: this.$t('yidiaobo'),
          value: 8
        }
      ],
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity'
        },
        {
          label: 'shengchanshuliang',
          prop: 'productionQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },

        {
          label: 'gongdanshunxu',
          prop: 'priority',
          width: 130
        },
        {
          label: 'jihuakaishishijian',
          prop: 'planStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'planEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijikaishishijian',
          prop: 'actualStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijiwanchengshijian',
          prop: 'actualEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'gongyizhinanbianma',
          prop: 'craftGuide.code',
          // type: 'slot',
          width: 130
        },

        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  filters: {
    getCode(value) {
      if (value != null) {
        return value
          .map(item => {
            return item.procedureCode;
          })
          .join(',');
      }
      return '';
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        planId: this.$attrs.work.id
        // orderBy: 'planStartTime,equipmentId asc',
      };
      this.yt.get(1);

      // this.yt.list = []
      // this.utils.event_hub.$on('PRODUCTION_MANAGEMENT_REFRESH', () => {
      // 	this.yt.get();
      // })
    }, 300);
  },
  methods: {
    showUpdateTimeDialog(row) {
      this.isShowUpDateTimeDialog = true;
      this.currentOrders = row;
    },
    async updateTime() {
      let params = {
        id: parseInt(this.currentOrders.id),
        planStartTime: this.timeForm.planStartTime,
        planEndTime: this.timeForm.planEndTime,
      };
      return await this.http
        .post("/web/production/wo/updatePlanTime", params)
        .then((res) => {
          this.isShowUpDateTimeDialog = false;
          this.isShowDetailDialog = false;
          this.timeForm = {
            planStartTime: null,
            planEndTime: null,
          };
          this.$message.success(this.$t(res.msg));
          this.refresh();
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    refresh() {
      this.yt.get(1);
      let params = {}
      params.id = this.$attrs.work.id
      this.http.get('/web/production/plan/get', {
        params: params
      }).then(res => {
        this.$attrs.work = res.data
      }).catch((err) => {
        this.utils.errorMessage(err)
      });
      this.utils.event_hub.$emit('ORDER_MANAGEMENT_REFRESH');
    },
    // 发放
    giveOut(row) {
      return this.http
        .post('/web/production/wo/giveOut', row.id)
        .then(res => {
          this.refresh();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 重新发放
    reGiveOut(row) {
      this.plan_work_order_re_give_out = true;
      return this.http
        .post('/web/production/wo/reGiveOut', row.id)
        .then(res => {
          this.refresh();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.plan_work_order_re_give_out = false;
        });
    },
    // 关闭
    close(row) {
      this.plan_work_order_close_loading = true;
      return this.http
        .post('/web/production/wo/close', row.id)
        .then(res => {
          this.refresh();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.plan_work_order_close_loading = false;
        });
    },
    exportExcel() {
      let params = {
        ...this.yt.conditions,
        pageNum: 1,
        pageSize: 999
      };
      delete params.orderBy;
      // let params = this.yt.conditions
      return this.http
        .get('/web/report/export/production_wo_report', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      };
      this.yt.list = [];
    },

    createQrCode(data) {
      this.http.post('/custom/qunlong/listProductionWorkOrders', { woId: data.id }).then(res => {
        if (res.data.length > 0) {
          this.qrContext = res.data[0].newQrcodeText;
          let editObj = this.utils.copy(data);
          editObj.wo = res.data[0];
          this.yt.showEditDialog('gongdanerweima', editObj, '500px');
        } else {
          this.$message.error(this.$t('zanwuerweimashujv'));
        }
      });
    },

    dayin() {
      html2canvas(document.getElementById('qunLongGongDanPrintDiv'), {
        scale: 2, // 处理模糊问题
        dpi: 300 // 处理模糊问题
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/jpg');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });
      });
      this.yt.isShowEditDialog = false;
    }
  }
};
</script>
